import { Price as TravelPrice } from 'models/travelDetails';
export type Tax = {
  code?: string;
  amount?: number;
};

export type Price = {
  taxes?: Tax[];
  total?: number;
  amount?: number;
  fees?: number;
  surcharges?: number;
  discountAmount?: number;
  commissionAmount?: number;
  currencyCode?: string;
  penaltyAmount?: number;
};

export type ResultPrice = {
  taxesValue?: number;
  total?: number;
  amount?: number;
  fees?: number;
  surcharges?: number;
  discountAmount?: number;
  commissionAmount?: number;
  currencyCode?: string;
  penaltyAmount?: number;
  fareResidualValue?: number;
  taxResidualValue?: number;
  totalResidualValue?: number;
};

export const mapPriceToVehicleRates = (price: TravelPrice): ResultPrice => ({
  taxesValue: price.taxes,
  total: price.total,
  amount: price.amount,
  surcharges: price.surcharges,
  fees: price.fees,
  discountAmount: price.discountAmount,
  commissionAmount: price.commissionAmount,
  currencyCode: price.currencyCode,
  penaltyAmount: price.penaltyAmount,
  fareResidualValue: price.fareResidualValue,
  taxResidualValue: price.taxResidualValue,
  totalResidualValue: price.totalResidualValue,
});
